import { axiosRequest } from './utils';

const createIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export async function fetchSupportMessages({ afterId, beforeId, limit } = {}) {
  const params = {};
  if (limit != null) params.limit = limit;
  if (afterId != null) params.after_id = afterId;
  if (beforeId != null) params.before_id = beforeId;

  const { data } = await axiosRequest.get('chat/messages', {
    params,
    _auth: true,
  });
  return data.messages || [];
}

export async function postSupportMessage(text) {
  const { data } = await axiosRequest.post(
    'chat/messages',
    { text },
    {
      _auth: true,
      headers: { 'Idempotency-Key': createIdempotencyKey() },
    }
  );
  return data;
}

export async function postSupportMessageMedia(file, caption) {
  const form = new FormData();
  if (caption) form.append('caption', caption);
  form.append('file', file, file.name);

  const { data } = await axiosRequest.post('chat/messages/media', form, {
    _auth: true,
    headers: { 'Idempotency-Key': createIdempotencyKey() },
  });
  return data;
}
